import "core-js/modules/es.array.concat.js";
// eslint-disable-line @typescript-eslint/no-explicit-any
// eslint-disable-line @typescript-eslint/no-explicit-any

function Memoized(func, error_handler) {
  var _this = this;
  this.cached_args = null;
  this.cached_response = null;
  this.error_handler = error_handler;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (_this.shouldCall.apply(_this, args)) {
      return _this.execute.apply(_this, [func].concat(args));
    }
    return _this.cached_response;
  };
}
Memoized.prototype.shouldCall = function memoizedShouldCall() {
  if (this.cached_args === null) return true;
  if (this.cached_args.length !== arguments.length) return true;
  for (var i = 0; i < arguments.length; i++) {
    if ((i < 0 || arguments.length <= i ? undefined : arguments[i]) !== this.cached_args[i]) return true;
  }
  return false;
};
Memoized.prototype.execute = function memoizedExecute(func) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  this.cached_args = args;
  try {
    this.cached_response = func.apply(void 0, args);
  } catch (err) {
    if (this.error_handler) {
      this.cached_response = this.error_handler.apply(this, [err].concat(args));
      return this.cached_response;
    }
    throw err;
  }
  return this.cached_response;
};

// @ts-expect-error TODO
export var memoizedNoError = function memoizedNoError(func) {
  return new Memoized(func, function () {
    return null;
  });
};
function memoized(func, error_handler) {
  // @ts-expect-error TODO
  return new Memoized(func, error_handler);
}
memoized.noError = memoizedNoError;
export default memoized;